// The month grid of the Rotations page (src/pages/RotationGrid.jsx): which crew_leave rows belong to which crew member, and
// the W / L of one day. Worked out ONCE per load (audit-100 item 5: the page matched every leave row against every name for
// every cell on every render - crew x 31 days x all rows, > 6 s on a phone), then one lookup per cell.
const norm = v => String(v || '').toLowerCase().replace(/\s+/g, ' ').trim()
const valOf = v => (v && typeof v === 'object' && 'value' in v) ? v.value : (v ?? '')

// a leave row's name is this crew member's: the same, one contains the other, or the same first and last word
export function sameCrew(nm, bn) {
  if (!bn || !nm) return false
  if (bn === nm || bn.includes(nm) || nm.includes(bn)) return true
  const nt = nm.split(' '), bt = bn.split(' ')
  return nt[0] === bt[0] && nt[nt.length - 1] === bt[bt.length - 1]
}
// names -> Map(name -> { spans: [{ start, end, working }], lastEnd }) in the order of the rows (the first span that holds a day wins)
export function crewSpans(names, blocks) {
  const rows = (blocks || []).map(b => ({ bn: norm(valOf(b['Crew Name'])), start: String(b['Start Date'] || ''), end: String(b['End Date'] || ''), working: (b['Leave Type'] || 'Leave') === 'Working' }))
  const out = new Map()
  for (const name of names) {
    const nm = norm(name)
    const mine = rows.filter(r => sameCrew(nm, r.bn))
    out.set(name, { spans: mine.filter(r => r.start && r.end), any: mine.length > 0, lastEnd: mine.reduce((mx, r) => (r.end > mx ? r.end : mx), '') })
  }
  return out
}
// 'W', 'L' or '' for one day. After the last recorded row and up to today the person's on-board flag fills the current period
// (the data import stops at a past date)
export function dayStatus(info, dayISO, onboard, todayISO) {
  if (!info) return ''
  for (const s of info.spans) if (dayISO >= s.start && dayISO <= s.end) return s.working ? 'W' : 'L'
  if (info.any && dayISO <= todayISO && info.lastEnd && dayISO > info.lastEnd) return onboard ? 'W' : 'L'
  return ''
}
